module.exports = __webpack_public_path__ + "static/media/upload.8aa20928.svg";